import { render, staticRenderFns } from "./DetalhesPartes.vue?vue&type=template&id=b0eb7bac&"
import script from "./DetalhesPartes.vue?vue&type=script&lang=js&"
export * from "./DetalhesPartes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports